<script>
	import { prefix, maxDemoWidth } from '../stores.js';

	import { createEventDispatcher } from 'svelte';

	export let buttonClass = '';
    export let buttonText;
	export let buttonBlink = false;

	const dispatch = createEventDispatcher();

	$: buttonClasses = $prefix + '-button ' + (buttonClass !== '' ? $prefix + '-button--' + buttonClass : '');

	function buttonClicked( event ) {
		dispatch('buttonClicked');
	}
</script>

<span class="{$maxDemoWidth ? $prefix + '-max-demo-width ' + buttonClasses : buttonClasses} {buttonBlink ? 'blink' : ''}" on:click={buttonClicked}>
    {buttonText}
</span>

<style type="text/scss">
    @import './sass/vars';

	.#{$prefix}-button {
		background-color: $primary;
		color: white;
		cursor: pointer;
		display: inline-block;
		text-align: center;
		padding: 0.875rem 1.875rem;
		border-radius: 2.25rem;
		line-height: 1.25rem;
		font-size: 1.125rem;
		font-family: avenir next lt w01 bold,helvetica,arial,sans-serif;		
		@media only screen and (max-width: $breakpoint-medium) {
			margin-top: 1rem;
		}

		&.blink {
			animation: buttonbling 3s infinite normal;
		}

		&--cta, &--cta-disabled {
			animation: buttonbling 3s infinite normal;
		}

		&--cta-disabled {
			animation: none;
			opacity: 50%;
			pointer-events: none;
		}

		&--dark {
			background-color: $primary-dark;
		}

		&--modal {
			border-radius: 2.25rem;
			animation: buttonbling 3s infinite normal;
			font-size: 1rem;
			padding: 1rem 1.25rem;
			
		}

	}
</style>
